import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import React from 'react'; // Ensure React is in scope for older JSX transforms

export default function CTA() {
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();

  return (
    <section
      id="contact"
      className="py-16 lg:py-24 bg-gradient-to-br from-brand-navy to-brand-navy-dark relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-brand-red rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-red rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div
        ref={ctaRef}
        className="max-w-[1400px] mx-auto px-6 relative z-10"
        style={{
          opacity: ctaVisible ? 1 : 0,
          transform: ctaVisible ? 'translateY(0) scale(1)' : 'translateY(40px) scale(0.96)',
          transition:
            'opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1), transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 lg:mb-6 leading-tight">
            Ready To Start Saving<br />On Energy Costs?
          </h2>
          <p className="text-base lg:text-xl text-white/90 mb-8 lg:mb-10 max-w-2xl mx-auto">
            Get your free home assessment and customized savings report
          </p>

          <a
            href="tel:+18005551234"
            className="inline-flex items-center gap-3 bg-brand-red text-white px-8 lg:px-10 py-4 lg:py-5 rounded-full text-base lg:text-lg font-bold hover:bg-brand-red-dark transition-all duration-300 hover:scale-105 mb-6 whitespace-nowrap cursor-pointer"
          >
            Schedule Free Consultation
            {/* Icon – keep it self‑closing to avoid any parsing ambiguity */}
            <i className="ri-arrow-right-line" />
          </a>

          <p className="text-white/90 text-base">
            Call us today:{' '}
            <a
              href="tel:+18005551234"
              className="font-bold hover:underline cursor-pointer"
            >
              (800) 555-1234
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
